import { Component } from "react"
import PropTypes from "prop-types"
import StencilField from "./stencil_field"
import { put, logError } from "shared/lib/api"

export default class SingleStencilForm extends Component {
  static propTypes = {
    stencil: PropTypes.object.isRequired,
    platformUnpublished: PropTypes.bool.isRequired,
    ingredientsMetadata: PropTypes.object,
  }

  state = {
    open: false,
    submitting: false,
  }

  handleSubmit = event => {
    event.preventDefault()
    this.setState({ submitting: true })

    const extractValuesFor = inputName =>
      event.target.querySelector(
        `[name='partner_trigger_stencil[${inputName}]']`
      ).value

    put(
      this.props.stencil.endpoint,
      {
        partner_trigger_stencil: {
          trigger_id: extractValuesFor("trigger_id"),
          value: extractValuesFor("value"),
        },
      },
      {
        Accept: "*/*",
      }
    )
      .then(() => {
        window.appendFlash("Applet default updated", "success")
      })
      .catch(
        logError(() => {
          window.appendFlash("Failed to save. Try again!", "danger")
        })
      )
      .finally(() => {
        this.setState({ submitting: false })
      })
  }

  render() {
    const { ingredientsMetadata, stencil } = this.props
    const iconClasses = ["action-header-icon", stencil.icon].join(" ")
    const openOrClosedClass = this.state.open ? "open" : "closed"

    return (
      <div className={`action-default ${openOrClosedClass}`}>
        <div
          className="action-header"
          onClick={() => this.setState({ open: !this.state.open })}
        >
          <div className={iconClasses} />
          <div className="action-header-title">
            <p>{stencil.name}</p>
            <p className="note">{stencil.example}</p>
          </div>
        </div>
        <form className="form" onSubmit={this.handleSubmit}>
          <input
            type="hidden"
            name="partner_trigger_stencil[trigger_id]"
            value={ingredientsMetadata.trigger.id}
          />
          <StencilField
            fieldName="partner_trigger_stencil[value]"
            ingredientsMetadata={ingredientsMetadata}
            stencil={stencil}
          />
          <div className="action">
            <button
              type="submit"
              className="button-secondary"
              disabled={
                this.state.submitting || !this.props.platformUnpublished
              }
            >
              {this.state.submitting ? "Saving…" : "Save"}
            </button>
          </div>
        </form>
      </div>
    )
  }
}
